var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWeatherConditions = function SvgWeatherConditions(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 480 487.61",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "weather_conditions_svg2__a",
    x1: -83.7,
    x2: 236.3,
    y1: 313.89,
    y2: -17.11,
    gradientTransform: "rotate(45 39.974 185.958)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_svg2__a",
    id: "weather_conditions_svg2__b",
    x1: -70.17,
    x2: 249.83,
    y1: 326.97,
    y2: -4.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_svg2__a",
    id: "weather_conditions_svg2__c",
    x1: 15.23,
    x2: 335.23,
    y1: 409.53,
    y2: 78.53
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_svg2__a",
    id: "weather_conditions_svg2__d",
    x1: -27.74,
    x2: 292.26,
    y1: 367.98,
    y2: 36.98,
    gradientTransform: "rotate(45 39.964 297.953)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_svg2__a",
    id: "weather_conditions_svg2__e",
    x1: 114.44,
    x2: 434.44,
    y1: 505.44,
    y2: 174.44
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_svg2__a",
    id: "weather_conditions_svg2__f",
    x1: 180.31,
    x2: 500.31,
    y1: 569.13,
    y2: 238.13,
    gradientTransform: "rotate(45 283.91 461.96)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_svg2__a",
    id: "weather_conditions_svg2__g",
    x1: 151.37,
    x2: 471.37,
    y1: 541.14,
    y2: 210.14,
    gradientTransform: "rotate(45 227.92 461.958)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_svg2__a",
    id: "weather_conditions_svg2__h",
    x1: 122.42,
    x2: 442.42,
    y1: 513.16,
    y2: 182.16,
    gradientTransform: "rotate(45 171.926 461.944)"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_svg2__a",
    id: "weather_conditions_svg2__i",
    x1: -20.28,
    x2: 299.72,
    y1: 375.2,
    y2: 44.2
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_svg2__a",
    id: "weather_conditions_svg2__j",
    x1: 117.49,
    x2: 437.49,
    y1: 508.39,
    y2: 177.39
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_svg2__a",
    id: "weather_conditions_svg2__k",
    x1: 143.41,
    x2: 463.41,
    y1: 533.45,
    y2: 202.45
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_svg2__a",
    id: "weather_conditions_svg2__l",
    x1: 62.29,
    x2: 382.29,
    y1: 455.03,
    y2: 124.03
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_svg2__a",
    id: "weather_conditions_svg2__m",
    x1: -26.76,
    x2: 293.24,
    y1: 368.94,
    y2: 37.94
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_svg2__a",
    id: "weather_conditions_svg2__n",
    x1: 16.67,
    x2: 336.67,
    y1: 410.92,
    y2: 79.92
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_svg2__a",
    id: "weather_conditions_svg2__o",
    x1: -68.72,
    x2: 251.28,
    y1: 328.37,
    y2: -2.63
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#weather_conditions_svg2__a",
    id: "weather_conditions_svg2__p",
    x1: 30.15,
    x2: 350.15,
    y1: 423.95,
    y2: 92.95,
    gradientTransform: "rotate(45 151.947 297.969)"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M31.97 174.65h16v22.62h-16z",
    style: {
      fill: "url(#weather_conditions_svg2__a)"
    },
    transform: "rotate(-45 39.969 185.964)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 233.98h24v16H0z",
    style: {
      fill: "url(#weather_conditions_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 313.98h16v24H88z",
    style: {
      fill: "url(#weather_conditions_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.65 289.95h22.62v16H28.65z",
    style: {
      fill: "url(#weather_conditions_svg2__d)"
    },
    transform: "rotate(-45 39.955 297.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304 329.98c0-35.35-28.65-64-64-64s-64 28.65-64 64c-26.51 0-48 21.49-48 48s21.49 48 48 48h128c26.51 0 48-21.49 48-48s-21.49-48-48-48m0 80H176c-17.67 0-32-14.33-32-32s14.33-32 32-32 32 14.33 32 32h16c-.03-20.3-12.8-38.39-31.91-45.22-.05-.93-.09-1.85-.09-2.78 0-26.51 21.49-48 48-48s48 21.49 48 48c0 12.9-5.19 25.26-14.41 34.29l11.2 11.43a63.6 63.6 0 0 0 17.19-29.64c.67-.04 1.35-.07 2.02-.07 17.67 0 32 14.33 32 32s-14.33 32-32 32Z",
    style: {
      fill: "url(#weather_conditions_svg2__e)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.64 453.96h56.56v16h-56.56z",
    style: {
      fill: "url(#weather_conditions_svg2__f)"
    },
    transform: "rotate(-45 283.922 461.966)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.64 453.95h56.56v16h-56.56z",
    style: {
      fill: "url(#weather_conditions_svg2__g)"
    },
    transform: "rotate(-45 227.926 461.95)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.65 453.95h56.56v16h-56.56z",
    style: {
      fill: "url(#weather_conditions_svg2__h)"
    },
    transform: "rotate(-45 171.925 461.947)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.02 133.95 11.19 11.44 32.13-31.41h51.36l-26.28 42.77-44.09 10.76 3.79 15.54 28.4-6.93-12.01 19.54 13.64 8.38 12.28-20 7.12 27.92 15.51-3.96-10.96-42.95 26.9-43.79 26.9 43.79L255.94 208l15.51 3.96 7.12-27.92 12.28 20 13.64-8.38-12.01-19.54 28.4 6.93 3.79-15.54-44.09-10.76-26.28-42.77h51.36l32.13 31.41 11.19-11.44-20.43-19.97H352v-16h-23.45l20.43-19.97-11.19-11.45-32.13 31.42H254.3l26.28-42.78 44.09-10.75-3.79-15.55-28.4 6.93 12.01-19.54-13.64-8.37-12.28 20L271.45 0l-15.51 3.96 10.96 42.95L240 90.7l-26.9-43.79 10.96-42.95L208.55 0l-7.12 27.92-12.28-20-13.64 8.37 12.01 19.54-28.4-6.93-3.79 15.55 44.09 10.75 26.28 42.78h-51.36l-32.13-31.42-11.19 11.45 20.43 19.97H128v16h23.45z",
    style: {
      fill: "url(#weather_conditions_svg2__i)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448 177.98h-16v16h16c8.84 0 16 7.16 16 16s-7.16 16-16 16H304v16h144c17.67 0 32-14.33 32-32s-14.33-32-32-32",
    style: {
      fill: "url(#weather_conditions_svg2__j)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416 257.98h-88v16h88c8.84 0 16 7.16 16 16s-7.16 16-16 16h-24v16h24c17.67 0 32-14.33 32-32s-14.33-32-32-32",
    style: {
      fill: "url(#weather_conditions_svg2__k)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264 225.98h24v16h-24z",
    style: {
      fill: "url(#weather_conditions_svg2__l)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 241.98c0-30.93-25.07-56-56-56s-56 25.07-56 56 25.07 56 56 56c30.91-.03 55.97-25.09 56-56m-96 0c0-22.09 17.91-40 40-40s40 17.91 40 40-17.91 40-40 40c-22.08-.03-39.97-17.92-40-40",
    style: {
      fill: "url(#weather_conditions_svg2__m)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168 233.98h24v16h-24z",
    style: {
      fill: "url(#weather_conditions_svg2__n)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88 145.98h16v24H88z",
    style: {
      fill: "url(#weather_conditions_svg2__o)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.95 286.65h16v22.62h-16z",
    style: {
      fill: "url(#weather_conditions_svg2__p)"
    },
    transform: "rotate(-45 151.94 297.964)"
  }));
};
export default SvgWeatherConditions;